/**
 * Runtime configuration, resolved once at module load.
 *
 * `window.__ENV__` is written by docker-entrypoint.sh at CONTAINER START from
 * the Deployment's env, so ONE image serves beta1 and production (plan §6.3).
 * The bundle used to have these inlined by Parcel at build time, which made a
 * different environment a different image. `process.env.*` remains the
 * fallback for a local `npm start`, where there is no entrypoint.
 *
 * The platform bundle at /platform reads the SAME env.js
 * (src/platform/lib/runtimeEnv.js): one BFF, one Keycloak client, one
 * environment label for the whole app.
 *
 * Every read is a STATIC `process.env.NAME`: Parcel inlines only those.
 */
const runtime = (typeof window !== 'undefined' && window.__ENV__) || {};

/** parsina.bff.marketing (MODE=staff) — the only server this app talks to. */
export const GRAPHQL_URL =
  runtime.MESHHUB_GRAPHQL_URL ||
  process.env.MESHHUB_GRAPHQL_URL ||
  'http://localhost:4003/graphql';

/** The BFF's origin; its REST routes (files, imports, exports, pairing) hang off it. */
export const BFF_ORIGIN = String(GRAPHQL_URL).replace(/\/graphql\/?$/, '').replace(/\/+$/, '');

/** Keycloak: realm `meshhub` and MeshHub's public client — sign-in follows MeshHub. */
export const OIDC_ISSUER = String(
  runtime.MESHHUB_OIDC_ISSUER ||
  process.env.MESHHUB_OIDC_ISSUER ||
  'https://sso.itechtrade.ir/realms/meshhub',
).replace(/\/+$/, '');

export const OIDC_CLIENT_ID =
  runtime.MESHHUB_OIDC_CLIENT_ID || process.env.MESHHUB_OIDC_CLIENT_ID || 'meshhub-admin-web';

/** Where the Users screen links out to for role changes. */
export const KEYCLOAK_ADMIN_URL =
  runtime.MESHHUB_KEYCLOAK_ADMIN_URL ||
  process.env.MESHHUB_KEYCLOAK_ADMIN_URL ||
  'https://sso.itechtrade.ir/admin/master/console/#/meshhub/users';

/**
 * Which deployment this is — beta1 or production serve the same image, so the
 * app is told and does not guess; an unset value is honestly `local`.
 */
export const ENV_NAME = runtime.PARSINA_ENV || process.env.PARSINA_ENV || 'local';

/** The other bundle: the platform back office (ex parsina.client.admin). */
export const PLATFORM_HOME = '/platform/';
